const AUTH0_DOMAIN_HOST = process.env.REACT_APP_AUTH0_DOMAIN ?? '';
const AUTH0_API_AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE;
const AUTH0_DOMAIN_URL = `https://${AUTH0_DOMAIN_HOST}`;
const AUTH0_LOGIN_SCOPE = 'offline_access openid profile email';
const AUTH0_OAUTH_TOKEN_URL = `${AUTH0_DOMAIN_URL}/oauth/token`;
const AUTH0_OAUTH_REVOKE_URL = `${AUTH0_DOMAIN_URL}/oauth/revoke`;

const SOCIAL_PROVIDER = {
  GOOGLE: 'google',
  APPLE: 'apple'
} as const;

export {
  AUTH0_DOMAIN_HOST,
  AUTH0_API_AUDIENCE,
  AUTH0_DOMAIN_URL,
  AUTH0_LOGIN_SCOPE,
  AUTH0_OAUTH_TOKEN_URL,
  AUTH0_OAUTH_REVOKE_URL,
  SOCIAL_PROVIDER
};
